import React, { useEffect, useState } from "react";

import "../asset/paiements.css";

import PaiementTable from "../../components/Paiement/Paiements/PaiementTable";
import PaiementForm from "../../components/Paiement/Paiements/PaiementForm";

import {
    getPaiements,
    createPaiement,
    updatePaiement,
    deletePaiement,
    getProfitTotal
} from "../../api/paiementService.api";

import {
    getModes
} from "../../api/modePaiement.api";

import {
    getRendezVous
} from "../../api/rendezVousService.api";


const PaiementsPage = () => {

    // =====================================================
    // STATES
    // =====================================================

    const [paiements, setPaiements] = useState([]);

    const [modesPaiement, setModesPaiement] = useState([]);

    const [rendezVous, setRendezVous] = useState([]);

    const [profitTotal, setProfitTotal] = useState(0);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const [showForm, setShowForm] = useState(false);

    const [paiementSelectionne, setPaiementSelectionne] =
        useState(null);

    // Accordion statistiques
    const [showStatistiques, setShowStatistiques] =
        useState(false);


    // =====================================================
    // CHARGER PAIEMENTS
    // =====================================================

    const chargerPaiements = async () => {

        try {

            const response = await getPaiements();

            const data = Array.isArray(response)
                ? response
                : response?.data || [];

            setPaiements(data);

        } catch (err) {

            console.error(
                "Erreur chargement paiements :",
                err
            );

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Erreur lors du chargement des paiements"
            );

        }
    };


    // =====================================================
    // CHARGER MODES DE PAIEMENT
    // =====================================================

    const chargerModesPaiement = async () => {

        try {

            const response = await getModes();

            const data = Array.isArray(response)
                ? response
                : response?.data || [];

            setModesPaiement(data);

        } catch (err) {

            console.error(
                "Erreur chargement modes paiement :",
                err
            );

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Erreur lors du chargement des modes de paiement"
            );

        }
    };


    // =====================================================
    // CHARGER RENDEZ-VOUS
    // =====================================================

    const chargerRendezVous = async () => {

        try {

            const response = await getRendezVous();

            const data = Array.isArray(response)
                ? response
                : response?.data || [];

            setRendezVous(data);

        } catch (err) {

            console.error(
                "Erreur chargement rendez-vous :",
                err
            );

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Erreur lors du chargement des rendez-vous"
            );

        }
    };


    // =====================================================
    // CHARGER PROFIT TOTAL
    // =====================================================

    const chargerProfitTotal = async () => {

        try {

            const response = await getProfitTotal();

            const profit =
                Number(response?.profit_total) ||
                Number(response?.data?.profit_total) ||
                0;

            setProfitTotal(profit);

        } catch (err) {

            console.error(
                "Erreur chargement profit total :",
                err
            );

            setProfitTotal(0);
        }
    };


    // =====================================================
    // CHARGEMENT INITIAL
    // =====================================================

    useEffect(() => {

        const chargerDonnees = async () => {

            try {

                setLoading(true);
                setError("");

                await Promise.all([
                    chargerPaiements(),
                    chargerModesPaiement(),
                    chargerRendezVous(),
                    chargerProfitTotal()
                ]);

            } catch (err) {

                console.error(
                    "Erreur chargement initial :",
                    err
                );

            } finally {

                setLoading(false);

            }
        };

        chargerDonnees();

    }, []);


    // =====================================================
    // ACTUALISER
    // =====================================================

    const actualiserDonnees = async () => {

        try {

            setLoading(true);
            setError("");

            await Promise.all([
                chargerPaiements(),
                chargerModesPaiement(),
                chargerRendezVous(),
                chargerProfitTotal()
            ]);

        } catch (err) {

            console.error(
                "Erreur actualisation :",
                err
            );

        } finally {

            setLoading(false);

        }
    };


    // =====================================================
    // AJOUTER PAIEMENT
    // =====================================================

    const handleAjouter = () => {

        setPaiementSelectionne(null);

        setError("");

        setShowForm(true);

    };


    // =====================================================
    // MODIFIER PAIEMENT
    // =====================================================

    const handleModifier = (paiement) => {

        setPaiementSelectionne(paiement);

        setError("");

        setShowForm(true);

    };


    // =====================================================
    // SUPPRIMER PAIEMENT
    // =====================================================

    const handleSupprimer = async (id) => {

        const confirmation = window.confirm(
            "Voulez-vous vraiment supprimer ce paiement ?"
        );

        if (!confirmation) {
            return;
        }

        try {

            setLoading(true);
            setError("");

            await deletePaiement(id);

            /*
             * Après suppression :
             * - recharge les paiements
             * - recharge les rendez-vous
             * - recharge le profit
             */

            await Promise.all([
                chargerPaiements(),
                chargerRendezVous(),
                chargerProfitTotal()
            ]);

        } catch (err) {

            console.error(
                "Erreur suppression paiement :",
                err
            );

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Erreur lors de la suppression du paiement"
            );

        } finally {

            setLoading(false);

        }
    };


    // =====================================================
    // ENREGISTRER PAIEMENT
    // =====================================================

    const handleSubmit = async (data) => {

        try {

            setError("");

            // -------------------------------------------------
            // MODIFICATION
            // -------------------------------------------------

            if (paiementSelectionne) {

                await updatePaiement(
                    paiementSelectionne.id,
                    data
                );

            }

            // -------------------------------------------------
            // CREATION
            // -------------------------------------------------

            else {

                await createPaiement(data);

            }


            // -------------------------------------------------
            // FERMER FORMULAIRE
            // -------------------------------------------------

            setShowForm(false);

            setPaiementSelectionne(null);


            // -------------------------------------------------
            // ACTUALISER
            // -------------------------------------------------

            await Promise.all([
                chargerPaiements(),
                chargerRendezVous(),
                chargerProfitTotal()
            ]);

        } catch (err) {

            console.error(
                "Erreur paiement :",
                err
            );

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Erreur lors de l'enregistrement du paiement"
            );

            throw err;
        }
    };


    // =====================================================
    // ANNULER
    // =====================================================

    const handleAnnuler = () => {

        setShowForm(false);

        setPaiementSelectionne(null);

        setError("");

    };


    // =====================================================
    // PROFIT FORMATÉ
    // =====================================================

    const profitFormate = Number(
        profitTotal || 0
    ).toLocaleString(
        "fr-FR",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );


    // =====================================================
    // STATISTIQUES
    // =====================================================

    const totalEncaisse = paiements
        .filter(
            (p) =>
                p.statut === "payé" ||
                p.statut === "partiel"
        )
        .reduce(
            (total, p) =>
                total + Number(p.montant || 0),
            0
        );


    const totalEncaisseFormate = totalEncaisse.toLocaleString(
        "fr-FR",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );


    const nombrePaiements = paiements.length;


    const nombrePayes = paiements.filter(
        (p) => p.statut === "payé"
    ).length;


    const nombrePartiels = paiements.filter(
        (p) => p.statut === "partiel"
    ).length;


    const nombreAnnules = paiements.filter(
        (p) =>
            p.statut === "annulé" ||
            p.statut === "annule"
    ).length;


    // =====================================================
    // RENDER
    // =====================================================

    return (

        <div className="paiements-page">


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="page-header">

                <div>

                    <h1>
                        Paiements
                    </h1>

                    <p>
                        Gestion des paiements des rendez-vous
                    </p>

                </div>


                <div className="page-actions">

                    <button
                        type="button"
                        onClick={actualiserDonnees}
                        disabled={loading}
                    >

                        {loading
                            ? "Chargement..."
                            : "Actualiser"
                        }

                    </button>


                    {!showForm && (

                        <button
                            type="button"
                            onClick={handleAjouter}
                        >

                            + Nouveau paiement

                        </button>

                    )}

                </div>

            </div>


            {/* =================================================
                STATISTIQUES - ACCORDION
            ================================================= */}

            {!showForm && (

                <div className="paiement-statistiques-accordion">


                    {/* =================================================
                        HEADER ACCORDION
                    ================================================= */}

                    <button
                        type="button"
                        className="paiement-statistiques-header"
                        onClick={() =>
                            setShowStatistiques(
                                !showStatistiques
                            )
                        }
                    >

                        <div className="paiement-statistiques-title">

                            <div className="paiement-statistiques-main-icon">
                                📊
                            </div>

                            <div>

                                <strong>
                                    Statistiques
                                </strong>

                                <small>
                                    Résumé financier des paiements
                                </small>

                            </div>

                        </div>


                        <span
                            className={
                                `paiement-statistiques-arrow ${
                                    showStatistiques
                                        ? "open"
                                        : ""
                                }`
                            }
                        >
                            ▼
                        </span>

                    </button>


                    {/* =================================================
                        CONTENU ACCORDION
                    ================================================= */}

                    {showStatistiques && (

                        <div className="paiement-statistiques-content">


                            {/* ================= PROFIT ================= */}

                            <div className="paiement-stat-card paiement-stat-profit">

                                <div className="paiement-stat-icon">
                                    💰
                                </div>

                                <div className="paiement-stat-content">

                                    <span>
                                        Profit total
                                    </span>

                                    <strong>
                                        {profitFormate} CAD
                                    </strong>

                                </div>

                            </div>


                            {/* ================= ENCAISSÉ ================= */}

                            <div className="paiement-stat-card paiement-stat-encaisse">

                                <div className="paiement-stat-icon">
                                    💵
                                </div>

                                <div className="paiement-stat-content">

                                    <span>
                                        Total encaissé
                                    </span>

                                    <strong>
                                        {totalEncaisseFormate} CAD
                                    </strong>

                                </div>

                            </div>


                            {/* ================= TOTAL ================= */}

                            <div className="paiement-stat-card paiement-stat-total">

                                <div className="paiement-stat-icon">
                                    🧾
                                </div>

                                <div className="paiement-stat-content">

                                    <span>
                                        Nombre de paiements
                                    </span>

                                    <strong>
                                        {nombrePaiements}
                                    </strong>

                                </div>

                            </div>


                            {/* ================= PAYÉS ================= */}

                            <div className="paiement-stat-card paiement-stat-paye">

                                <div className="paiement-stat-icon">
                                    ✅
                                </div>

                                <div className="paiement-stat-content">

                                    <span>
                                        Paiements payés
                                    </span>

                                    <strong>
                                        {nombrePayes}
                                    </strong>

                                </div>

                            </div>


                            {/* ================= PARTIELS ================= */}

                            <div className="paiement-stat-card paiement-stat-partiel">

                                <div className="paiement-stat-icon">
                                    🟠
                                </div>

                                <div className="paiement-stat-content">

                                    <span>
                                        Paiements partiels
                                    </span>

                                    <strong>
                                        {nombrePartiels}
                                    </strong>

                                </div>

                            </div>


                            {/* ================= ANNULÉS ================= */}

                            <div className="paiement-stat-card paiement-stat-annule">

                                <div className="paiement-stat-icon">
                                    ❌
                                </div>

                                <div className="paiement-stat-content">

                                    <span>
                                        Paiements annulés
                                    </span>

                                    <strong>
                                        {nombreAnnules}
                                    </strong>

                                </div>

                            </div>


                        </div>

                    )}

                </div>

            )}


            {/* =================================================
                ERREUR
            ================================================= */}

            {error && (

                <div className="alert alert-danger">

                    ⚠️ {error}

                </div>

            )}


            {/* =================================================
                FORMULAIRE
            ================================================= */}

            {showForm && (

                <PaiementForm

                    paiement={
                        paiementSelectionne
                    }

                    modesPaiement={
                        modesPaiement
                    }

                    rendezVous={
                        rendezVous
                    }

                    onSubmit={
                        handleSubmit
                    }

                    onCancel={
                        handleAnnuler
                    }

                    loading={
                        loading
                    }

                />

            )}


            {/* =================================================
                TABLEAU
            ================================================= */}

            {!showForm && (

                <PaiementTable

                    paiements={
                        paiements
                    }

                    loading={
                        loading
                    }

                    onEdit={
                        handleModifier
                    }

                    onDelete={
                        handleSupprimer
                    }

                />

            )}

        </div>
    );
};


export default PaiementsPage;